import { iconsSet } from "../../../../assets/icons/icons";
import defaultContent from "../default";

const wordsToBold = [
  "MISSÃO:",
  "VISÃO:",
  "VALORES:",
  "Aprendizagem permanente:",
  "Inovação continua:",
  "Ética:",
];

const paragraphs = [
  "MISSÃO: Facilitar o acesso de pessoas físicas a soluções de investimento eficientes e tecnológicas.",
  "VISÃO: Ser a referência em acessibilidade e inovação no mercado de renda variável no Brasil. ",
  "VALORES:<br/>Aprendizagem permanente: Buscar conhecimento contínuo para entregar a nossos clientes os melhores retornos. ",
  "Inovação continua: Realizar processos interativos de aprimoramento da tecnológica para oferecer soluções com maior segurança e mais benefícios ",
  "Ética: Atuar em total concordância com os princípios do mercado e as normas vigentes ",
];

function makeBold(input, wordsToBold, col) {
  setTimeout(() => {
    let text = input;
    if (text.charAt(0) == "É") {
      text = input.replace(
        new RegExp("(\\B)(" + wordsToBold.join("|") + ")(\\B)", "gui"),
        "$1<span class='font-bold'>$2</span>$3"
      );
    } else {
      text = input.replace(
        new RegExp("(\\b)(" + wordsToBold.join("|") + ")(\\B)", "gui"),
        "$1<span class='font-bold'>$2</span>$3"
      );
    }
    let p = document.createElement("p");
    p.innerHTML = text;
    document.getElementById(col).appendChild(p);
  }, 2000);
}

for (let i = 0; i < paragraphs.length; i++) {
  makeBold(paragraphs[i], wordsToBold, "col2");
}

export default {
  hero: {
    img: {
      url: "https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/mockup_lp_tradefacil.png",
      alt: "Estratégias TRADE FÁCIL",
    },
    title: "Ganhe Tempo e Dinheiro com a TRADE FÁCIL",

    // String ou array de strings
    text: [
      "Chega de passar horas na frente dos gráficos tentando adivinhar a direção dos preços. Seja você um Trader Iniciante, Avançado ou Profissional, facilitamos seu serviço para que tenha lucros percentuais acima da média do mercado de renda variável.",
    ],
    testimonial: {
      text: "Queremos democratizar o acesso a renda variável",
      author: {
        name: "Joelson Gomes – CEO Trade Facil",
        // picture:
        //   "https://ontick-img.s3.sa-east-1.amazonaws.com/mauro_quantic_profile.png",
      },
    },
  },

  strategies: {
    title: "Estratégias Day Trade para Minicontratos Futuros",
    heading: "O jeito fácil de fazer dinheiro no automático",
    subtitle:
      "E com o algoritmo da TRADE FACIL você tem a segurança que apenas sistemas quantitativos podem oferecer para negociações com ativos de alta volatilidade.",
  },

  cta: {
    title: "Você já lucra com Day Trade?",
    subtitle: "Temos um plano certo para o seu momento",
    buttonText: "Ver planos",
  },

  about: {
    title: "Sobre a empresa",
    subtitle: "TRADE FACIL",
    col1: [
      "Somos uma Fintech com foco na democratização do mercado da renda variável, possibilitando que qualquer pessoa seja um Trader Profissional.",
      "A ideia de automatizar negociações em ativos de renda variável começou a mais de 15 anos, ainda no Microsoft Excel, e passou por diversas tentativas e frustações ao longo dos anos até que em 2021 o projeto foi retomado, agora no Metatrader, e não parou mais.",
      "Hoje provemos sistemas quantitativos de análise gráfica e estatística dos preços, tendo por base um Algoritmo que interpreta a essência do mercado de renda variável.",
      "Estamos transformando o jeito que o brasileiro investe! Faça parte dessa transformação.",
    ],
    col2: [
      // "VISÃO: Ser a referência em acessibilidade e inovação no mercado de renda variável no Brasil. ",
      // "VALORES:",
      // "Aprendizagem permanente: Buscar conhecimento contínuo para entregar a nossos clientes os melhores retornos. ",
      // "Inovação continua: Realizar processos interativos de aprimoramento da tecnológica para oferecer soluções com maior segurança e mais benefícios ",
      // "Ética: Atuar em total concordância com os princípios do mercado e as normas vigentes ",
    ],
  },

  // stats: {
  //   title: "Diferenciais das estratégias TRADE FACIL",
  //   subtitle: "",
  //   data: [
  //     {
  //       value: "INOVAÇÃO E TECNOLOGIA",
  //       description:
  //         "Solução que simplifica o complexo trabalho de um Trader automatizando negociações em ativos de alta volatilidade",
  //     },
  //     {
  //       value: "EFICIENCIA E PRECISÃO",
  //       description:
  //         "Estatística e matemática aplicada na análise dos preços e no gerenciamento de risco para proteção do capital",
  //     },
  //     {
  //       value: "SEGURANÇA E RENTABILIDADE",
  //       description:
  //         "Sistemas quantitativos de análise de preços, sem o fator emocional humano, reduzem erros e tem maiores chances de obter Lucro",
  //     },
  //     {
  //       value: "MELHORES RESULTADOS",
  //       description:
  //         "Toda negociação tem monitoramento do Stop Móvel, a fim de minimizar prejuízos e maximizar lucros",
  //     },
  //   ],
  //   smalltext: true,
  // },

  features: {
    // type: 2,
    title: "Por que utilizar os nossos robôs?",
    subtitle: "Veja quais as principais vantagens dos nossos robôs.",
    data: [
      {
        icon: iconsSet.lightning,
        title: "Eficiência",
        description:
          "Estatística e Matemática Aplicada com conceitos de Inteligência Artificial na tomada de decisão para operações de compra e venda de ativos de alta volatilidade",
      },
      {
        icon: iconsSet.lock,
        title: "Segurança",
        description:
          "Todas as operações tem valores de Objetivo, Ganho Parcial e STOP definidos na Entrada do Trade, garantindo um gerenciamento de risco efetivo.",
      },
      {
        icon: iconsSet.code,
        title: "100% automatizado",
        description:
          "Realizamos todos os ajustes e parametrizações das estratégias automaticamente",
      },
      {
        icon: iconsSet.clock,
        title: "Ganhe Tempo",
        description:
          "Você não precisa ficar na frente do computador para realizar as operações. Escolha as estratégias e deixe que a plataforma opere por você.",
      },
      {
        icon: iconsSet.favorite,
        title: "Sem Emocional",
        description:
          "Sistemas quantitativos de análise do comportamento dos preços de ativos, sem o fator humano, reduzem erros e tem maiores chances de lucrar.",
      },
      {
        icon: iconsSet.calendar,
        title: "7 dias para testar",
        description:
          "Teste nossas estratégias e confira a performance em sua conta.",
      },

      // ...defaultContent.features.data,
    ],
  },

  // testimonials: [
  //   {
  //     text: "Tenho recomendado a trade2go a todos os amigos e familiares. Os resultados incríveis que obtive superaram minhas expectativas, sem falar no suporte excepcional da equipe que faz toda a diferença. Recomendo demais para quem busca sucesso no mercado financeiro.",
  //     author: "Alexandre Melara",
  //     job: "Consultor",
  //     // image_url:
  //     //   "https://newbot.com.br/wp-content/uploads/2018/03/eliseu-sandres-120x120.jpg",
  //   },
  //   {
  //     text: "Graças às estratégias da trade2go, finalmente encontrei uma forma de potencializar meus investimentos com minicontratos eliminando o aspecto emocional.",
  //     author: "Ricardo Silva",
  //     job: "Administrador de Empresas",
  //     // image_url:
  //     //   "https://newbot.com.br/wp-content/uploads/2018/03/Victor-nardi-vilella-120x120.jpg",
  //   },
  // ],

  plans: {
    title: "Planos",
    subtitle: "Conheça nossos planos e vantagens!",
  },
};

// https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/mockup_lp_algotrading.png
